module.exports = __webpack_public_path__ + "static/img/buyernoData.3db20899.png";